import { Group, Stack, Text, Title } from '@mantine/core';
import useIsMobile from '../hooks/useIsMobile';

const PageHeader = ({ eyebrow, title, description, actions }) => {
  const isMobile = useIsMobile();

  return (
    <Group justify="space-between" align="flex-start" gap={isMobile ? 'md' : 'lg'} wrap="wrap">
      <Stack gap={6} style={{ flex: 1, minWidth: 0 }}>
        {eyebrow && (
          <Text size="xs" fw={800} c="indigo.6" tt="uppercase" style={{ letterSpacing: '0.12em' }}>
            {eyebrow}
          </Text>
        )}
        <Title
          order={2}
          fw={900}
          style={{
            letterSpacing: '-0.03em',
            fontSize: isMobile ? '1.65rem' : undefined,
            lineHeight: isMobile ? 1.05 : undefined,
          }}
        >
          {title}
        </Title>
        {description && (
          <Text c="dimmed" maw={720} size={isMobile ? 'sm' : 'md'} style={{ lineHeight: 1.55 }}>
            {description}
          </Text>
        )}
      </Stack>
      {actions ? (
        <Group
          gap="sm"
          align="center"
          wrap="wrap"
          style={{
            width: isMobile ? '100%' : 'auto',
            justifyContent: isMobile ? 'stretch' : undefined,
            alignItems: 'stretch',
          }}
        >
          {actions}
        </Group>
      ) : null}
    </Group>
  );
};

export default PageHeader;
